const rewardPackOracleAbi = [
	{
		"inputs": [
			{
				"internalType": "contract RewardPacks",
				"name": "_rewardPacks",
				"type": "address"
			},
			{
				"internalType": "contract IActivePools",
				"name": "_activePools",
				"type": "address"
			},
			{
				"internalType": "contract IDEXRouter",
				"name": "router",
				"type": "address"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"inputs": [],
		"name": "activePools",
		"outputs": [
			{
				"internalType": "contract IActivePools",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "getReflectionPoolCount",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			}
		],
		"name": "getShareHolder",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "shares",
				"type": "uint256"
			},
			{
				"internalType": "bool",
				"name": "isExistingUser",
				"type": "bool"
			},
			{
				"internalType": "uint256",
				"name": "totalSubscriptionWeight",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			}
		],
		"name": "getSubscribedPools",
		"outputs": [
			{
				"internalType": "uint256[10]",
				"name": "subscribedPools",
				"type": "uint256[10]"
			},
			{
				"internalType": "uint256",
				"name": "cutOff",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			}
		],
		"name": "getTokenPoolData",
		"outputs": [
			{
				"components": [
					{
						"internalType": "address",
						"name": "_tokenAddress",
						"type": "address"
					},
					{
						"internalType": "string",
						"name": "_name",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "_symbol",
						"type": "string"
					},
					{
						"internalType": "uint256",
						"name": "_decimals",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_totalSupply",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_poolID",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_shareCount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_totalDistributed",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_bnbPending",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_balanceOfHolder",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_amountBalanceWorthAggreggated",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_unclaimedAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_claimedAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_holderPoolShares",
						"type": "uint256"
					},
					{
						"internalType": "address",
						"name": "_reflectionPoolAddress",
						"type": "address"
					}
				],
				"internalType": "struct RocketFiOracleLibrary.PoolData[]",
				"name": "_poolData",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "batchNumber",
				"type": "uint256"
			}
		],
		"name": "getTokenPoolDataBatch",
		"outputs": [
			{
				"components": [
					{
						"internalType": "address",
						"name": "_tokenAddress",
						"type": "address"
					},
					{
						"internalType": "string",
						"name": "_name",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "_symbol",
						"type": "string"
					},
					{
						"internalType": "uint256",
						"name": "_decimals",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_totalSupply",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_poolID",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_shareCount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_totalDistributed",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_bnbPending",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_balanceOfHolder",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_amountBalanceWorthAggreggated",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_unclaimedAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_claimedAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_holderPoolShares",
						"type": "uint256"
					},
					{
						"internalType": "address",
						"name": "_reflectionPoolAddress",
						"type": "address"
					}
				],
				"internalType": "struct RocketFiOracleLibrary.PoolData[]",
				"name": "_poolData",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "batchNumber",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "batchSize",
				"type": "uint256"
			}
		],
		"name": "getTokenPoolDataCustom",
		"outputs": [
			{
				"components": [
					{
						"internalType": "address",
						"name": "_tokenAddress",
						"type": "address"
					},
					{
						"internalType": "string",
						"name": "_name",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "_symbol",
						"type": "string"
					},
					{
						"internalType": "uint256",
						"name": "_decimals",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_totalSupply",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_poolID",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_shareCount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_totalDistributed",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_bnbPending",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_balanceOfHolder",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_amountBalanceWorthAggreggated",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_unclaimedAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_claimedAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_holderPoolShares",
						"type": "uint256"
					},
					{
						"internalType": "address",
						"name": "_reflectionPoolAddress",
						"type": "address"
					}
				],
				"internalType": "struct RocketFiOracleLibrary.PoolData[]",
				"name": "_poolData",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "batchSize",
				"type": "uint256"
			}
		],
		"name": "getTotalCalls",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "totalBatches",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "activeCount",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "rewardPacks",
		"outputs": [
			{
				"internalType": "contract RewardPacks",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "totalShares",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
];

export default rewardPackOracleAbi;